import Model from '@/store/model';
import Speaking from './skills/speaking';
import Writing from './skills/writing';
import Listening from './skills/listening';
import Reading from './skills/reading';
import Vocabulary from './skills/vocabulary';

class SkillPoint extends Model {
  map(json) {
    super.map(json);

    this.speaking = new Speaking();
    this.speaking.map(json.speaking);

    this.writing = new Writing();
    this.writing.map(json.writing);

    this.listening = new Listening();
    this.listening.map(json.listening);

    this.reading = new Reading();
    this.reading.map(json.reading);

    this.vocabulary = new Vocabulary();
    this.vocabulary.map(json.vocabulary);
  }
}
export default SkillPoint;
